import React, { useEffect, useRef, useState } from "react";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { ResourceDWR } from "../../../dto/ResourceDWR";
import { Button } from "@mui/material";
import axios from "axios";
import { getISBNList } from "@tlc/ls2pac/app/utils/PACStandardNumberUtil";

export interface TeachingBooksData {
  enabled: boolean; // TODO is this returned as isEnabled?
  oauthCallback: string;
  oauthConsumerKey: string;
  oauthNOnce: string;
  oauthSignature: string;
  oauthSignatureMethod: string;
  oauthTimestamp: string;
  oauthVersion: string;
  ltiVersion: string;
  ltiMessageType: string;
  link: string;
}

export interface TeachingBooksButtonProps {
  resource: ResourceDWR;
  logoType?: "vertical" | "horizontal";
}

export const TeachingBooksButton: React.FC<TeachingBooksButtonProps> = ({
  resource,
  logoType = "horizontal",
}) => {
  const { locationConfiguration } = useLocationConfiguration();

  if (!locationConfiguration?.pacSettings.useTeachingBooks) {
    return null;
  }
  const formRef = useRef<HTMLFormElement>(null);
  const [teachingBooksFormData, setTeachingBooksFormData] =
    useState<TeachingBooksData | null>(null);
  const [teachingBooksTitleId, setTeachingBooksTitleId] = useState(null);

  useEffect(() => {
    // request teaching books title id
    const getTeachingBooksId = async () => {
      const isbns = getISBNList(resource.standardNumbers);
      try {
        // TODO create a context to cache these responses if fairly static
        const { data } = await axios.post<number | null>(
          `/teachingBooks/titleId`,
          isbns
        );

        setTeachingBooksTitleId(data);
      } catch (e) {
        console.log("error getting teaching books title id");
      }
    };

    getTeachingBooksId();
  }, [resource.id]);

  const onClickTeachingBooks = async () => {
    if (!teachingBooksTitleId) return;
    try {
      const { data } = await axios.get<TeachingBooksData>(
        `/teachingBooks/formData/${teachingBooksTitleId}`
      );
      // need to use a form for cross-domain POSTs that open a new tab
      setTeachingBooksFormData(data);
      // wait for the form inputs to render then submit
      setTimeout(() => {
        formRef.current?.submit();
      }, 0);
    } catch (e) {
      console.error("error fetching teaching books form data");
    }
  };

  return (
    teachingBooksTitleId && (
      <>
        {/* TODO move .teachingBooksLink button styles here */}
        <Button aria-label="TeachingBooks" onClick={onClickTeachingBooks}>
          {/* 300px w x 73px h */}
          <img
            height={logoType === "vertical" ? "48px" : "36px"}
            src={
              logoType === "vertical"
                ? "images/logo-teachingbooks-vertical.png"
                : "images/logo-teachingbooks.png"
            }
            alt="TeachingBooks"
          />
        </Button>

        <form
          ref={formRef}
          method="POST"
          target="_blank"
          action={teachingBooksFormData?.link || ""}
          style={{ display: "none" }}
        >
          <input
            type="hidden"
            name="oauth_callback"
            value={teachingBooksFormData?.oauthCallback}
          />
          <input
            type="hidden"
            name="oauth_consumer_key"
            value={teachingBooksFormData?.oauthConsumerKey}
          />
          <input
            type="hidden"
            name="oauth_nonce"
            value={teachingBooksFormData?.oauthNOnce}
          />
          <input
            type="hidden"
            name="oauth_signature"
            value={teachingBooksFormData?.oauthSignature}
          />
          <input
            type="hidden"
            name="oauth_signature_method"
            value={teachingBooksFormData?.oauthSignatureMethod}
          />
          <input
            type="hidden"
            name="oauth_timestamp"
            value={teachingBooksFormData?.oauthTimestamp}
          />
          <input
            type="hidden"
            name="oauth_version"
            value={teachingBooksFormData?.oauthVersion}
          />
          <input
            type="hidden"
            name="lti_version"
            value={teachingBooksFormData?.ltiVersion}
          />
          <input
            type="hidden"
            name="lti_message_type"
            value={teachingBooksFormData?.ltiMessageType}
          />
        </form>
      </>
    )
  );
};
